import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";
import { observer } from "mobx-react-lite";
import ButtonWithProgress from "reusable/mui/progress-button/ButtonWithProgress";
import useStore from "reusable/mobx-store-utils";
import { Signee, useProposalsViewProposalStore } from "../../ProposalsViewProposalStore";
import { useProposalSectionAcceptanceStore } from "./ProposalSectionAcceptanceStore";
import { themeConfig } from '@gap/shared/theme';
import Box from "@mui/material/Box";
import ProposalSectionAcceptanceSigneeStore from "./ProposalSectionAcceptanceSigneeStore";

export interface ProposalSectionAcceptanceSigneeProps {
   signee: Signee
   currentUserCanSign: boolean
   onSigned: () => Promise<void>
}

export default observer(function ProposalSectionAcceptanceSignee(props: ProposalSectionAcceptanceSigneeProps) {
   const proposalsViewProposalStore = useProposalsViewProposalStore()
   const proposalSectionAcceptanceStore = useProposalSectionAcceptanceStore()

   const proposalSectionAcceptanceSigneeStore = useStore(sp => new ProposalSectionAcceptanceSigneeStore(sp), {
      ...props,
      proposalSectionAcceptanceStore,
      proposalsViewProposalStore
   })

   return <Stack>
      <Stack sx={{
         borderBottom: `1px dashed ${themeConfig.primary[200]}`,
         py: 1,
         flexDirection: 'row',
         alignItems: 'center',
         gap: 2,
         justifyContent: 'space-between',
         color: props.currentUserCanSign && !proposalsViewProposalStore.isProposalAccepted ? themeConfig.primary[800] : themeConfig.primary[400]
      }}>
         <Typography variant="subtitle1" sx={{ py: '2px' }}>{props.signee.name}</Typography>
         {!props.signee.agreedAt && props.currentUserCanSign
            && <ButtonWithProgress
               variant="contained"
               onClick={proposalSectionAcceptanceSigneeStore.signHandler}
               disabled={proposalSectionAcceptanceSigneeStore.signHandlerDisabled}
               icon={<CheckIcon />}
               iconAndLoadingPosition="start"
               loading={proposalSectionAcceptanceSigneeStore.signLoader.isLoading}
            >I agree</ButtonWithProgress>}
      </Stack>

      <Box
         sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            mt: 1,
            color: props.currentUserCanSign && !proposalsViewProposalStore.isProposalAccepted ? 'secondary.light' : themeConfig.primary[400]
         }}
      >
         {!!props.signee.agreedAt && <CheckIcon fontSize="small" />}
         <Typography variant="caption">{proposalSectionAcceptanceSigneeStore.signText}</Typography>
      </Box>
   </Stack>
})
